import { cn } from "@/lib/utils";

interface UserAvatarProps {
  user: { name?: string | null; image?: string | null };
  className?: string;
}

function initials(name?: string | null): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).slice(0, 2);
  const joined = parts.map((p) => p.charAt(0).toUpperCase()).join("");
  return joined || "?";
}

export function UserAvatar({ user, className }: UserAvatarProps) {
  const src =
    user.image && (user.image.startsWith("http") || user.image.startsWith("/")) ? user.image : null;

  return (
    <span
      className={cn(
        "inline-flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/10 text-xs font-medium text-primary",
        className,
      )}
    >
      {src ? (
        <img src={src} alt={user.name ?? "Avatar"} className="h-full w-full object-cover" />
      ) : (
        initials(user.name)
      )}
    </span>
  );
}
